// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article_recherche_filter {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-start;
    margin-top: 50px;
}

.results_title {
    width: 100%;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 30px;
}

.result_text {
    font-size: var(--font-size-page-title);
    color: var(--couleur-principale);
    font-weight: var(--font-weight-title);
}

.article_recherche_filter_item {
    flex: 1 1 30%;
    min-width: 220px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.article_recherche_filter_item.price {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.article_recherche_filter_item.dropdowns {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.article_recherche_filter_item input,
.article_recherche_filter_item select,
.article_recherche_filter_item .btn {
    width: 100%;
    border-radius: 10px;
    background-color: transparent;
    color: var(--gris-primaire);
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.article_recherche_filter_item .btn::after {
    height: 5px;
}

.btn-group.dropend {
    width: 100%;
}

.article_recherche_icon_localisation {
    height: 50px;
    border-radius: 15px 0 0 15px;
    background: transparent;
}

.pagination-loadmore {
    width: 100%;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
}

.btn-loadmore {
    background: var(--couleur-principale);
    color: var(--white-principale);
    border: none;
    padding: 12px 22px;
    border-radius: 6px;
    font-size: var(--font-size-loadmore);
    cursor: pointer;
    transition: 0.2s ease;
}

.btn-loadmore:hover {
    background: var(--couleur-secondaire);
}

.article_recherche_results>* {
    min-width: 235px;
    margin-bottom: 30px;
}

.article_recherche_results {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fill, minmax(235px, 1fr));
    overflow-x: hidden;
    scroll-behavior: smooth;
    padding-bottom: 20px;
}

.article_recherche_results>* {
    min-width: unset;
    width: 100%;
}

.article_recherche_results.active {
    cursor: grabbing;
    cursor: -webkit-grabbing;
}

.article_recherche_results {
    cursor: grab;
    cursor: -webkit-grab;
}

.no_result_container {
    width: 100%;
    padding: 60px 20px;
    text-align: center;
    color: #666;
}

.no_result_image {
    width: 160px;
    margin-bottom: 20px;
    opacity: 0.8;
}

.no_result_container h3 {
    font-size: var(--font-size-no-result-title);
    font-weight: var(--font-weight-title);
    margin-bottom: 8px;
    color: #222;
}

.no_result_container p {
    font-size: var(--font-size-no-result-text);
    color: #777;
}

.menu_search {
    background-color: var(--white-secondaire);
    border-radius: 10px;
    cursor: pointer;
}

.support_content_recherche {
    width: 100%;
    background-color: var(--gris-foncer);
    padding: 50px;
}

.support_faq_header {
    margin: 10px 0 18px;
    padding: 14px 14px 10px;
    border-radius: 16px;
    background: rgba(255, 255, 255, .75);
    border: 1px solid rgba(15, 23, 42, .10);
    box-shadow: 0 10px 24px rgba(2, 6, 23, .08);
}

.support_faq_badge {
    display: inline-flex;
    align-items: center;
    padding: 6px 10px;
    border-radius: 999px;
    font-weight: 700;
    font-size: var(--font-size-badge); 
    background: rgba(15, 23, 42, .06);
    color: #0f172a;
}


.support_faq_heading {
    margin: 10px 0 6px;
    font-size: var(--font-size-detail-section); 
    font-weight: 800;
    color: #0f172a;
}

.support_faq_desc {
    margin: 0;
    color: #475569;
    line-height: 1.55;
    font-size: var(--font-size-detail-text); 
}

@media (min-width: 1025px) {
    .article_recherche_results {
        grid-template-columns: repeat(5, 1fr);
    }

    .article_recherche_results>* {
        min-width: unset;
        width: 100%;
    }

}

@media (min-width: 769px) and (max-width: 1024px) {
    .article_recherche_results {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .article_recherche_results {
        grid-template-columns: 1fr;
        gap: 15px;
    }

    .article_recherche_results>* {
        scroll-snap-align: start;
        flex: 0 0 auto;
    }

    .article_recherche_results::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    .article_recherche_filter {
        flex-direction: column;
        gap: 15px;
        justify-content: center;
        align-items: center;
    }

    .article_recherche_filter_item {
        flex: 1 1 100%;
        width: 100%;
    }

    .article_recherche_filter_item.price {
        flex-direction: row;
        gap: 10px;
        flex-wrap: wrap;
    }

    .article_recherche_filter_item.price .input-group {
        flex: 1 1 48%;
    }

    .btn-group.dropend {
        width: 48%;
    }

}

@media (max-width: 480px) {

    .article_recherche_filter_item.price .input-group,
    .btn-group.dropend {
        flex: 1 1 100%;
    }

    .article_recherche_results {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .support_content_recherche {
        padding: 5px;
    }

}`, "",{"version":3,"sources":["webpack://./src/assets/css/article/ArticleRecherche.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;;;IAGI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,4DAA4D;IAC5D,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,uCAAuC;IACvC,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,iCAAiC;IACjC,iCAAiC;IACjC,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;AAEJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,wBAAwB;QACxB,cAAc;IAClB;;IAEA;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;AAEJ;;AAEA;;IAEI;;QAEI,cAAc;IAClB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;AAEJ","sourcesContent":[".article_recherche_filter {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    align-items: flex-start;\n    margin-top: 50px;\n}\n\n.results_title {\n    width: 100%;\n    text-align: left;\n    margin-top: 20px;\n    margin-bottom: 30px;\n}\n\n.result_text {\n    font-size: var(--font-size-page-title);\n    color: var(--couleur-principale);\n    font-weight: var(--font-weight-title);\n}\n\n.article_recherche_filter_item {\n    flex: 1 1 30%;\n    min-width: 220px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.article_recherche_filter_item.price {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n.article_recherche_filter_item.dropdowns {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n.article_recherche_filter_item input,\n.article_recherche_filter_item select,\n.article_recherche_filter_item .btn {\n    width: 100%;\n    border-radius: 10px;\n    background-color: transparent;\n    color: var(--gris-primaire);\n    height: 50px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.article_recherche_filter_item .btn::after {\n    height: 5px;\n}\n\n.btn-group.dropend {\n    width: 100%;\n}\n\n.article_recherche_icon_localisation {\n    height: 50px;\n    border-radius: 15px 0 0 15px;\n    background: transparent;\n}\n\n.pagination-loadmore {\n    width: 100%;\n    text-align: center;\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.btn-loadmore {\n    background: var(--couleur-principale);\n    color: var(--white-principale);\n    border: none;\n    padding: 12px 22px;\n    border-radius: 6px;\n    font-size: var(--font-size-loadmore);\n    cursor: pointer;\n    transition: 0.2s ease;\n}\n\n.btn-loadmore:hover {\n    background: var(--couleur-secondaire);\n}\n\n.article_recherche_results>* {\n    min-width: 235px;\n    margin-bottom: 30px;\n}\n\n.article_recherche_results {\n    display: grid;\n    gap: 20px;\n    grid-template-columns: repeat(auto-fill, minmax(235px, 1fr));\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n    padding-bottom: 20px;\n}\n\n.article_recherche_results>* {\n    min-width: unset;\n    width: 100%;\n}\n\n.article_recherche_results.active {\n    cursor: grabbing;\n    cursor: -webkit-grabbing;\n}\n\n.article_recherche_results {\n    cursor: grab;\n    cursor: -webkit-grab;\n}\n\n.no_result_container {\n    width: 100%;\n    padding: 60px 20px;\n    text-align: center;\n    color: #666;\n}\n\n.no_result_image {\n    width: 160px;\n    margin-bottom: 20px;\n    opacity: 0.8;\n}\n\n.no_result_container h3 {\n    font-size: var(--font-size-no-result-title);\n    font-weight: var(--font-weight-title);\n    margin-bottom: 8px;\n    color: #222;\n}\n\n.no_result_container p {\n    font-size: var(--font-size-no-result-text);\n    color: #777;\n}\n\n.menu_search {\n    background-color: var(--white-secondaire);\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.support_content_recherche {\n    width: 100%;\n    background-color: var(--gris-foncer);\n    padding: 50px;\n}\n\n.support_faq_header {\n    margin: 10px 0 18px;\n    padding: 14px 14px 10px;\n    border-radius: 16px;\n    background: rgba(255, 255, 255, .75);\n    border: 1px solid rgba(15, 23, 42, .10);\n    box-shadow: 0 10px 24px rgba(2, 6, 23, .08);\n}\n\n.support_faq_badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 6px 10px;\n    border-radius: 999px;\n    font-weight: 700;\n    font-size: var(--font-size-badge); \n    background: rgba(15, 23, 42, .06);\n    color: #0f172a;\n}\n\n\n.support_faq_heading {\n    margin: 10px 0 6px;\n    font-size: var(--font-size-detail-section); \n    font-weight: 800;\n    color: #0f172a;\n}\n\n.support_faq_desc {\n    margin: 0;\n    color: #475569;\n    line-height: 1.55;\n    font-size: var(--font-size-detail-text); \n}\n\n@media (min-width: 1025px) {\n    .article_recherche_results {\n        grid-template-columns: repeat(5, 1fr);\n    }\n\n    .article_recherche_results>* {\n        min-width: unset;\n        width: 100%;\n    }\n\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    .article_recherche_results {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .article_recherche_results {\n        grid-template-columns: 1fr;\n        gap: 15px;\n    }\n\n    .article_recherche_results>* {\n        scroll-snap-align: start;\n        flex: 0 0 auto;\n    }\n\n    .article_recherche_results::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n    }\n\n    .article_recherche_filter {\n        flex-direction: column;\n        gap: 15px;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .article_recherche_filter_item {\n        flex: 1 1 100%;\n        width: 100%;\n    }\n\n    .article_recherche_filter_item.price {\n        flex-direction: row;\n        gap: 10px;\n        flex-wrap: wrap;\n    }\n\n    .article_recherche_filter_item.price .input-group {\n        flex: 1 1 48%;\n    }\n\n    .btn-group.dropend {\n        width: 48%;\n    }\n\n}\n\n@media (max-width: 480px) {\n\n    .article_recherche_filter_item.price .input-group,\n    .btn-group.dropend {\n        flex: 1 1 100%;\n    }\n\n    .article_recherche_results {\n        grid-template-columns: 1fr;\n        gap: 12px;\n    }\n\n    .support_content_recherche {\n        padding: 5px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
